export default "__VITE_ASSET__Ds067vx3__"